import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { omit } from 'ramda';

import { ISpoilerProps } from './types';

export const useSpoiler = (props: ISpoilerProps) => {
  const { data, onChange, readOnly, id, setActiveItem } = props;
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const styleDndButton = {
    transform: CSS.Translate.toString(transform),
    transition: transform ? transition : undefined,
    userSelect: 'none',
    pointerEvents: isDragging ? 'none' : undefined,
    zIndex: isDragging ? 9999 : undefined,
    opacity: isDragging ? 0.2 : undefined,
  };

  const handleChangeTitle = (title: string) => {
    if (readOnly) return;
    onChange({ ...data, title });
  };

  const handleChangeBody = ({ data: wData }: any) => {
    if (readOnly) return;
    onChange({ ...data, body: wData });
  };

  const handleDeleteBody = () => {
    if (readOnly) return;
    onChange(omit(['body'], data));
  };

  const handleOnMouseDown = (e: MouseEvent) => {
    setActiveItem(-1);
    setTimeout(() => {
      if (listeners) {
        listeners.onMouseDown(e);
      }
    }, 100);
  };

  const handleOnKeyDown = (e: MouseEvent) => {
    if (listeners) {
      listeners.onKeyDown(e);
    }
  };
  const handleOnTouchStart = (e: TouchEvent) => {
    setActiveItem(-1);
    setTimeout(() => {
      if (listeners) {
        listeners.onTouchStart(e);
      }
    }, 100);
  };

  return {
    attributes,
    setNodeRef,
    styleDndButton,
    handleChangeTitle,
    handleChangeBody,
    handleDeleteBody,
    handleOnTouchStart,
    handleOnMouseDown,
    handleOnKeyDown,
  };
};
